// Feature flags — set to false to re-enable pricing UI and plan locks
export const PRICING_HIDDEN = true
